<template>
  <application-layout>
    <v-container fluid class="mx-auto px-6">
      <v-tabs v-model="tab" icons-and-text class="mt-4 mb-6 mx-0 px-0">
        <v-tab
          data-testid="ar-dashboard-tenant-list-tab"
          class="ar-dashboard-tenant-list-tab"
          style="width: 11.75rem"
        >
          <span class="text-capitalize">A/R Tenant List</span>
          <v-icon class="pb-1" large>web</v-icon>
        </v-tab>
        <v-tab
          data-testid="ar-dashboard-payment-plans-tab"
          class="ar-dashboard-payment-plans-tab"
          style="width: 11.75rem"
        >
          <span class="text-capitalize">Payment Plans</span>
          <v-icon class="pb-1" large>query_builder</v-icon>
        </v-tab>
        <v-tab
          data-testid="ar-dashboard-promise-to-pay-tab"
          class="ar-dashboard-promise-to-pay-tab"
          style="width: 11.75rem"
        >
          <span class="text-capitalize">Promise-to-Pay</span>
          <v-icon class="pb-1" large>credit_card</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item eager>
          <v-row>
            <v-col cols="5">
              <failed-table />
              <pending-table />
            </v-col>
            <v-col cols="7">
              <calls-table />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item eager>
          <v-row>
            <v-col cols="12">
              <plans-table />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item eager>
          <v-row>
            <v-col cols="12">
              <promise-table />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>

      <pusher-handler @incomingCall="openIncomingCallModal($event)" />

      <application-modal v-model="incomingCallModal">
        <div slot="modal-title">Incoming Call</div>
        <div slot="modal-body" style="min-height: 2rem">
          <v-layout align-start class="mt-2 mb-1" v-if="callData">
            Incoming call for Facility
            <span class="info--text">&nbsp;{{ callData.location_code }}</span
            >.
          </v-layout>
        </div>
        <v-btn
          data-testid="reject-call-btn"
          class="reject-call-btn"
          slot="cancel-button"
          color="error"
          :disabled="loading"
          @click="declineCall"
        >
          <span>
            <slot name="cancel-text">Reject Call</slot>
          </span>
        </v-btn>
        <v-btn
          data-testid="accept-call-btn"
          class="accept-call-btn primary"
          slot="create-button"
          :loading="loading"
          @click="acceptIncomingCall"
        >
          Accept Call
        </v-btn>
      </application-modal>
    </v-container>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout";
import ApplicationModal from "@/components/ApplicationModal";
import CallsTable from "./partials/CallsTable";
import FailedTable from "./partials/FailedTable";
import PendingTable from "./partials/PendingTable";
import PlansTable from "./partials/PlansTable";
import PromiseTable from "./partials/PromiseTable";
import { mapState } from "vuex";

export default {
  name: "ARIndex",
  components: {
    ApplicationModal,
    PendingTable,
    PromiseTable,
    PlansTable,
    CallsTable,
    FailedTable,
    ApplicationLayout
  },
  data() {
    return {
      callData: null,
      incomingCallModal: false,
      loading: false,
      tab: 0
    };
  },

  methods: {
    openIncomingCallModal(callData) {
      this.callData = callData;
      this.incomingCallModal = true;
    },

    acceptIncomingCall() {
      this.loading = true;
      let incomingCallPayload = {
        ctm_id: parseFloat(this.callData.ctm_id),
        call_type: "accounts-receivable-incoming",
        location_code: this.callData.location_code
      };

      this.$store
        .dispatch("beginCall", incomingCallPayload)
        .then((resp) => {
          let localStoragePayload = {
            locationCode: incomingCallPayload.location_code,
            reservationId: null,
            callId: resp.data.call.id,
            ctm_id: incomingCallPayload.ctm_id,
            call_type: incomingCallPayload.call_type,
            contact_id: null,
            tenant_id: null
          };
          this.$store.dispatch("routeCall", localStoragePayload);
        })
        .catch((err) => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },

    declineCall() {
      this.callData = null;
      this.incomingCallModal = false;
      this.$store.dispatch("handleError", "Call was rejected.");
    }
  },

  computed: {
    ...mapState({
      darkMode: (state) => state.application.settings.darkTheme
    })
  },

  created() {
    localStorage.setItem("arActive", "true");
  },

  beforeDestroy() {
    localStorage.removeItem("arActive");
  }
};
</script>
